// db/names.ts
var baseUserClassName = "BaseUser";
var adornisUserClassName = "AdornisUser";
var adornisRolesClassName = "AdornisRoles";
var currentUserInfoClassName = "CurrentUserInfo";
var adornisRoleToContextsWrapperClassName = "AdornisRoleToContextsWrapper";
var adornisUserCollectionName = "adornisuser";
var adornisRolesCollectionName = "adornisroles";
export {
  adornisRoleToContextsWrapperClassName,
  adornisRolesClassName,
  adornisRolesCollectionName,
  adornisUserClassName,
  adornisUserCollectionName,
  baseUserClassName,
  currentUserInfoClassName
};
